import React, { useEffect, useState } from 'react';
import { buscarBeneficiariosGasto } from '../../services/data';
import { useAutocompletar, BotonLimpiar } from './useAutocompletar';

export default function BeneficiarioAutocomplete({ value, beneficiarioId, onChange, disabled }) {
  const [opciones, setOpciones] = useState([]);
  const { abierto, setAbierto, ref, listId, propsInput, limpiar, botonCerrar } = useAutocompletar();
  useEffect(() => {
    if (!abierto) return undefined;
    let vigente = true;
    const t = setTimeout(() => buscarBeneficiariosGasto(value).then((r) => { if (vigente) setOpciones(r); })
      .catch(() => { if (vigente) setOpciones([]); }), 200);
    return () => { vigente = false; clearTimeout(t); };
  }, [value, abierto]);
  const exacto = opciones.find((b) => b.nombre.trim().toLowerCase() === String(value || '').trim().toLowerCase());
  return <div className="prod-auto" ref={ref}>
    <span className="auto-campo">
      <input {...propsInput} value={value || ''} disabled={disabled} maxLength={200} aria-label="Beneficiario" className={!disabled && value ? 'auto-con-limpiar' : undefined}
        placeholder="Buscar o escribir beneficiario" onChange={(e) => { onChange({ beneficiario: e.target.value, beneficiarioId: null }); setAbierto(true); }}
        onBlur={() => { if (!beneficiarioId && exacto) onChange({ beneficiario: exacto.nombre, beneficiarioId: exacto.id }); }} />
      <BotonLimpiar visible={!disabled && !!value} etiqueta="Limpiar beneficiario" onClick={() => limpiar(() => onChange({ beneficiario: '', beneficiarioId: null }))} />
    </span>
    {!disabled && value && !beneficiarioId && !abierto && <small className="prod-auto-nuevo">Pendiente de revisar</small>}
    {abierto && !disabled && <ul id={listId} role="listbox" className="prod-auto-lista">
          {botonCerrar}
      {opciones.map((b) => <li key={b.id} role="option" aria-selected={b.id === beneficiarioId}><button type="button" onPointerDown={(e) => { e.preventDefault(); onChange({ beneficiario: b.nombre, beneficiarioId: b.id }); setAbierto(false); }}
        onClick={() => { onChange({ beneficiario: b.nombre, beneficiarioId: b.id }); setAbierto(false); }}>{b.nombre}</button></li>)}
      {value && !exacto && <li className="prod-auto-libre"><button type="button" onPointerDown={(e) => { e.preventDefault(); setAbierto(false); }} onClick={() => setAbierto(false)}>Usar “{value}” (pendiente de revisar)</button></li>}
    </ul>}
  </div>;
}
